export const USER_REGEX = /^[A-z][A-z0-9-_]{3,23}$/;
export const EMAIL_REGEX = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;